module.exports = __webpack_public_path__ + "assets/img/ic-export.7fa54e51.svg";